import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import SwiperCore, {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
import {BodyContext} from '~/context/BodyContext.js'
import {WalletManager, Api} from '~/scripts'
import {Swiper, SwiperSlide} from "swiper/react";
import $ from "jquery";


export class Punker extends Component {
    static contextType = BodyContext;

    constructor(props) {
        super(props)
        this.state = {
            interf: {
                isTransferingPunk: false,
                pathname: window.location.pathname,

            },
        }
    }

    componentWillMount() {
        const [CT] = this.context;
        this.CT = CT
        // this.CT.set_classing({
        //     route: 'mypunks',
        // });
    }

    async bridge_transfer(e, id) {
        e.preventDefault();
        this.CT.swal(null, {
            title: 'Transfer Punk To Another',
            body: `
                <p>
                    Enter Wallet Address
                </p>
                <br />
                <div class="InputBox -full">
                    <input type="text" placeholder="To Address" id="TRANSFER_ADDRESS" />
                    <i class="ri-input-cursor-move"></i>
                </div>
            `,
            modify: {
                confirmButtonText: 'Send'
            }
        }).then(async res => this._sst('form', {newoffer_price: $('#TRANSFER_ADDRESS').val()}, () => {
            this.makeTransfer($('#TRANSFER_ADDRESS').val(), id);
        }))
    }

    async _submitAction(id) {
        Api.get(`/update?token_id=${id}`)
    }

    async makeTransfer(destAddress, id) {

        let checkAddress = window.web3.utils.isAddress(destAddress);
        if (checkAddress) {
            const {interf, form, storage} = this.state
            const selectedWallet = await WalletManager.getSelectedWallet();
            if (destAddress.toLowerCase() == selectedWallet.toLowerCase()) {
                this.CT.swal('error', {
                    title: `Transfer Failed`,
                    body: `You cant send to your current wallet`
                })
            } else {
                this._sst('interf', {isTransferingPunk: true})
                setTimeout(async () => {
                    try {
                        await window.contract.methods.safeTransferFrom(selectedWallet, destAddress, id).send({
                            from: selectedWallet,
                        }, (error, result) => {
                            if (result) {
                                this.CT.swal('success', {
                                    title: 'Transfer successfully done!',
                                    body: `Refresh page after Transferred finished`
                                })
                                this._submitAction(id)
                            } else {
                                this.CT.swal('error', {
                                    title: 'Transfer Rejected'
                                })
                            }
                            this._sst('interf', {isTransferingPunk: false})
                        });

                    } catch (e) {
                        console.log(e);
                        this.CT.swal('error', {
                            title: `Transfer Failed`,
                            body: `wallet address is not valid `
                        })
                        this._sst('interf', {isTransferingPunk: false})
                    } finally {
                        this._sst('interf', {isTransferingPunk: false})
                    }
                }, 500);
            }
        } else {
            this.CT.swal('error', {
                title: `Transfer Failed`,
                body: `wallet address is not valid `
            })
        }
    }

    async _sst(main, obj, callback) {
        this.setState({
            [main]: {
                ...this.state[main],
                ...obj
            }
        }, () => callback ? callback() : null)
    }

    render() {
        const Punks = this.props.punksData || [];
        const isSlidy = this.props.slidy
        const isLight = this.props.light
        const isFixitems = this.props.fixitems
        const appendStyle_punk = {
            backgroundColor: isLight ? '#f5f5f5' : '#ffffff',
            flexBasis: isFixitems ? '31%' : 'auto'
        }
        const appendStyle_container = {
            justifyContent: isFixitems ? 'flex-start' : 'flex-start',
            alignContent: 'flex-start',
        }
        SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
        return (
            <>
                <div className={`Punkontainer`} style={{
                    flexDirection: this.props.slidy ? 'column' : 'row',
                    ...appendStyle_container
                }}>
                    {isSlidy
                        ?
                        <Swiper
                            freeMode
                            className="custome_swiper"
                        >
                            {Punks.map((Punk, i) => {
                                return (
                                    <SwiperSlide>
                                        <Link
                                            className={`Punkard ${this.props.punksActiveList ? (this.props.punksActiveList.includes(Punk.idx) ? '-active' : '') : ''}`}
                                            key={Punk.idx}
                                            to={this.props.connect ? `/marketplace/${Punk.idx}` : '/'}
                                            style={{
                                                ...appendStyle_punk
                                            }}
                                        >
                                            <div className="character">
                                                <div className="IC">
                                                    <img
                                                        src={`https://market.etcpunks.com/punksimg/pic/${Punk.idx}.png`}
                                                        alt=""/>
                                                </div>
                                            </div>
                                            <div className="info">
                                                <div className="basic">
                                                    <div className="name">
                                                        <span>
                                                            {Punk.idx}
                                                        </span>
                                                        <strong className="type">
                                                            {Punk.type}
                                                        </strong>
                                                    </div>
                                                    <div className="attrs">
                                                        {Punk.attributes.map((attr, ii) => {
                                                            return (
                                                                <div className={`attr`} key={ii}>
                                                                    <span>
                                                                        {attr}
                                                                    </span>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>

                                                <div className="extra">
                                                    {Punk.extra &&
                                                    <>
                                                        <div className="price">
                                                                <span>
                                                                    {Punk.extra.punksOfferedForSale[0] && (window.web3Global && window.web3Global.utils.fromWei(Punk.extra.punksOfferedForSale.minValue))}
                                                                </span>
                                                        </div>
                                                        <div className="bid">
                                                                <span>
                                                                    {Punk.extra.punkBids[0] && (window.web3Global && window.web3Global.utils.fromWei(Punk.extra.punkBids.value)) || '-'}
                                                                </span>
                                                        </div>
                                                    </>
                                                    }
                                                </div>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                )
                            })}
                            <SwiperSlide>
                                <div className={`and_more`}>
                                    <div className="Actions">
                                        <Link className="Btn" to="/punks">
                                            <i className="ri-more-line"></i>
                                            <span>
                                                And more
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        :
                        Punks.map((Punk, i) => {
                            return (

                                <Link
                                    className={`Punkard ${this.props.punksActiveList ? (this.props.punksActiveList.includes(i) ? '-active' : '') : ''}`}
                                    key={Punk.idx}
                                    
                                    to={this.props.connect ? `/marketplace/${Punk.idx}` : '/'}
                                    style={{
                                        imageRendering: 'pixelated',
                                        ...appendStyle_punk
                                    }}
                                >
                                    <div className="character">
                                        <div className="IC">
                                            <img
                                                src={`https://market.etcpunks.com/punksimg/pic/${Punk.idx}.png`}
                                                alt=""/>
                                        </div>
                                    </div>

                                    <div className="info">
                                        <div className="basic">
                                            <div className="name">
                                                <span>
                                                    {Punk.idx}
                                                </span>
                                                <strong className="type">
                                                    {Punk.type}
                                                </strong>
                                                {this.props.market &&
                                                <strong className="price">
                                                    {/* {Punk.price} */}
                                                    210 MATICS
                                                </strong>
                                                }

                                            </div>
                                            <div className="attrs">

                                                {Punk.attributes && Punk.attributes.map((attr, ii) => {
                                                    return (
                                                        <div className={`attr`} key={ii}>
                                                            <span>
                                                                {attr}
                                                            </span>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            {window.location.pathname==='/mypunks'?
                                                <button type="button" className="Btn -simple2"
                                                        onClick={(event) => this.bridge_transfer(event, Punk.idx)}>
                                                    <i className="ri-file-transfer-fill"></i>
                                                    <span>Transfer</span>
                                                </button>
                                            :''
                                            }

                                        </div>
                                        <div className="extra">
                                            {Punk.extra &&
                                            <>
                                                <div className="price">
                                                        <span>
                                                            {Punk.extra.punksOfferedForSale[0] && (window.web3Global && window.web3Global.utils.fromWei(Punk.extra.punksOfferedForSale.minValue))}
                                                        </span>
                                                </div>
                                                <div className="bid">
                                                        <span>
                                                            {Punk.extra.punkBids[0] && (window.web3Global && window.web3Global.utils.fromWei(Punk.extra.punkBids.value)) || '-'}
                                                        </span>
                                                </div>
                                            </>
                                            }
                                        </div>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>
            </>
        )
    }
}